<template>
    <section class="invoice">
        <invoice-nav />
        <div class="top_section">
            <h1 class="title">{{ $t("Invoice") }}</h1>
        </div>

        <div id="main">
            <div class="head">
                <div class="logo">
                    <img src="../assets/images/logo.png" alt />
                </div>
                <div class="b-address">
                    <div class="address-item">
                        <h2>Saudi Arabia:</h2>
                        <div>
                            <p>King's Road Tower</p>
                            <p>Level 26th</p>
                            <p>Jeddah, Saudi Arabia</p>
                            <p>+966 557974722</p>
                        </div>
                    </div>
                    <div class="address-item">
                        <h2>United States:</h2>
                        <div>
                            <p>8135 Uehling Ln</p>
                            <p>Huber Heights, Ohaio 45424</p>
                            <p>United States</p>
                            <p>+1 (248)403-2828</p>
                        </div>
                    </div>
                </div>
                <div class="title">
                    <p class="num">
                        {{ $t("Invoice #") }} {{ invoice.identifier }}
                    </p>
                    <p class="detail">
                        <span
                            style="
                                display: block;
                                border-bottom: 1px solid #ddd;
                                margin-bottom: 10px;
                                padding-bottom: 10px;
                            "
                        >
                            {{ $t("Issued at") }}
                            <span style="padding: 0 8px; font-weight: bold">{{
                                invoice.issued_at | moment("DD MMM YYYY")
                            }}</span>
                        </span>

                        <span style="display: block">
                            {{ $t("Due date") }}
                            <span style="padding: 0 8px; font-weight: bold">{{
                                invoice.due_date | moment("DD MMM YYYY")
                            }}</span>
                        </span>
                    </p>
                </div>
            </div>
            <div class="body">
                <div class="address_title">
                    <h3>{{ $t("Billing address") }}</h3>
                </div>

                <div class="address">
                    <h4 class="name">{{ invoice.user.full_name }}</h4>
                    <div class="info">
                        <div>
                            <p>{{ invoice.user.mobile }}</p>
                            <p>{{ invoice.user.email }}</p>
                        </div>
                    </div>
                </div>

                <div class="table">
                    <table>
                        <thead>
                            <tr>
                                <th>{{ $t("Order ID") }}</th>
                                <th>{{ $t("Tracking Number") }}</th>
                                <th>{{ $t("Ship Date") }}</th>
                                <th>{{ $t("Vendor") }}</th>
                                <th>{{ $t("Weight") }}</th>
                                <th>{{ $t("Cost") }}</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, i) in invoice.items" :key="i">
                                <td style="font-weight: bold">
                                    {{ item.order.identifier }}
                                </td>
                                <td>
                                    {{ item.order.vendor_shipment_id || "-" }}
                                </td>
                                <td>
                                    {{
                                        item.order.shipment_date
                                            | moment("DD MMM YYYY")
                                    }}
                                </td>
                                <td>{{ item.order.vendor_name }}</td>
                                <td>
                                    {{ item.order.total_weight }}
                                    {{ $t("KG") }}
                                </td>
                                <td class="primary">
                                    {{ item.total_debit | currency("") }}
                                    {{ $t("SAR") }}
                                </td>
                                <td class="primary" style="padding: 0">
                                    <router-link
                                        :to="
                                            '/shipment-details/' + item.order_id
                                        "
                                        class="button"
                                        >{{ $t("View details") }}</router-link
                                    >
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="page-break"></div>
            <div class="footer">
                <div class="pill">
                    <div>
                        <p>{{ $t("Total") }}</p>
                        <p class="position-relative">
                            {{
                                invoice.total_amount
                                    ? invoice.total_amount
                                    : invoice.amount | currency("")
                            }}
                            <span class="cur">{{ $t("SAR") }}</span>
                        </p>
                    </div>
                    <div>
                        <p>{{ $t("Paid") }}</p>
                        <p class="position-relative">
                            {{ invoice.PaidAmount | currency("") }}
                            <span class="cur">{{ $t("SAR") }}</span>
                        </p>
                    </div>
                </div>

                <div class="amount">
                    <div class="inv-num">
                        <img
                            class="barcode"
                            style="width: 400px"
                            src="@/assets/images/Barcode.svg"
                            alt
                        />
                        <p>{{ invoice.identifier }}</p>
                    </div>
                    <div class="inv-price">
                        <p class="inv-t">{{ $t("Total Due Amount") }}</p>
                        <p class="inv-p">
                            <span class="n">
                                {{
                                    invoice.DueAmount > 0
                                        ? invoice.DueAmount
                                        : 0 | currency("")
                                }}
                            </span>
                            <span class="c">{{ $t("SAR") }}</span>
                        </p>
                        <button
                            v-if="invoice.DueAmount > 0"
                            class="button"
                            @click="makePayment(invoice.id, invoice.DueAmount)"
                        >
                            {{ $t("Make Payment") }}
                        </button>
                    </div>
                </div>
                <div class="link">
                    <h2>www.ALKOON.com</h2>
                </div>
            </div>
        </div>

        <div class="options">
            <button class="button">
                {{ $t("Contact ALKOON customer service") }}
            </button>
            <button class="button" v-print="printOptions">
                {{ $t("Print invoice") }}
            </button>
        </div>
    </section>
</template>

<script>
import invoiceNav from "@/components/Nav/invoiceNav.vue";

export default {
    components: {
        invoiceNav,
    },
    data() {
        return {
            printOptions: {
                id: "main",
                popTitle: "good print",
            },
        };
    },
    computed: {
        invoice() {
            return this.$store.getters.invoice;
        },
    },
    methods: {
        makePayment(id, due_amount) {
            sessionStorage.setItem("invoice_due_amount", due_amount);
            this.$router.push("/invoice-checkout/" + id);
        },
    },
    created() {
        if (isNaN(this.$route.params.id)) return this.$router.go(-1);
        this.$store.dispatch("INVOICE", {
            service:
                this.$route.query.is_group == 1 ? "Group_Invoice" : "invoice",
            reqPayload: this.$route.params.id,
        });
    },
};
</script>

<style lang="scss">
.link {
    text-align: right;

    h2 {
        margin: 0;
        font-size: 20px;
        opacity: 0.7;
    }
}

.b-address {
    display: flex;
    align-items: flex-end;
    direction: ltr;

    .address-item {
        margin: 0 30px;

        h2 {
            font-size: 20px;
            font-weight: bold;
            opacity: 0.9;
        }

        p {
            font-size: 15px;
        }
    }
}

.invoice {
    background: #f2f2f280;
    padding: 0 100px;
    margin-top: -120px;
}

.top_section {
    margin-bottom: 30px;

    .title {
        font-size: 3rem;
        font-weight: lighter;
    }
}

#main {
    background-image: url("../assets/images/paper_bg.png");
    background-size: cover;
    padding: 30px 50px 0;
    width: 1000px;
    margin: auto;
    margin-bottom: 10px;
    border-radius: 0 0 10px 10px;

    .position-relative {
        position: relative;
    }

    .currency {
        position: absolute;
        bottom: 5px;
        width: 100px;
        font-size: 10px;
        padding: 0 5px;
    }

    .head {
        border-bottom: 1px solid #ddd;
        padding: 30px 30px;

        .logo {
            display: flex;
            flex-flow: row-reverse;
            margin: 35px 7px;
            opacity: 0.5;

            img {
                width: 200px;
            }
        }

        .title {
            p {
                &.detail {
                    font-size: 15px;
                    font-weight: bold;
                    background: #f7f7f7;
                    display: inline-block;
                    padding: 10px 30px;
                    border-radius: 50px;
                    margin: 10px 0;
                }
            }
        }
    }

    .body {
        padding: 10px 70px;

        .address_title {
            padding-top: 15px;
            border-bottom: 1px solid #ddd;
            font-weight: bold;
            font-size: 1.5rem;
        }

        .address {
            .name {
                font-size: 25px;
                font-weight: bold;
                margin: 15px 0;
            }

            .info {
                margin-top: 10px;

                div {
                    margin-bottom: 15px;

                    p {
                        font-size: 15px;
                        font-weight: bold;
                        color: #777;
                    }
                }
            }
        }

        .table {
            margin-top: 40px;
            padding: 0;

            table {
                width: 100%;

                thead {
                    background: #f7f7f7;
                    border-radius: 5px;
                }

                th {
                    padding-top: 11px;
                    padding-bottom: 11px;
                }

                tbody {
                    tr {
                        border-bottom: 1px solid #ddd;
                        height: 60px;

                        td {
                            vertical-align: middle;

                            .button {
                                padding: 0 10px;
                                font-size: 11px;
                            }
                        }
                    }
                }

                .total {
                    font-weight: bold;
                    text-align: center;
                }

                .primary {
                    color: #4952ff;
                    font-weight: bold;
                }

                .danger {
                    color: #ff7977;
                    font-weight: bold;
                }
            }
        }
    }

    .footer {
        margin-top: 60px;
        background: none;

        border-top: 1px solid #ddd;

        .pill {
            padding: 0 70px;

            div {
                display: flex;
                justify-content: space-between;

                p {
                    font-weight: bold;
                    font-size: 20px;

                    .cur {
                        font-size: 12px;
                    }
                }
            }
        }

        .amount {
            margin-top: 80px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .inv-num {
                width: 70%;
                text-align: center;

                p {
                    letter-spacing: 13px;
                    font-size: 15px;
                    color: #777;
                }
            }

            .inv-price {
                width: 30%;
                text-align: center;

                .inv-t {
                    font-size: 18px;
                    font-weight: bold;
                    color: #777;
                }

                .inv-p {
                    font-weight: bold;
                    position: relative;

                    span {
                        &.n {
                            padding: 0 5px;
                            font-size: 40px;
                        }

                        &.c {
                            font-size: 20px;
                        }
                    }
                }

                .button {
                    width: 95%;
                    background: none;
                    color: black;
                    height: 30px;
                    font-size: 14px;
                    border-color: #777 !important;
                }
            }
        }
    }
}

@page {
    size: A4;
    margin: 30px 0;
    -webkit-print-color-adjust: exact;
}

@media print {
    .page-break {
        display: block;
        page-break-before: always;
    }

    body {
        margin: 0;
        padding: 0;
    }

    #main {
        -webkit-print-color-adjust: exact;
        margin: 0;
        padding: 0;

        // position: absolute;
        // top: 0;
        // left: 0;
        // right: 0;
        // padding: 0;
        // margin: 0;
        .head {
            border-bottom: 1px solid #ddd;
            padding: 10px 20px;

            .logo {
                margin: 15px 7px;

                img {
                    width: 100px;
                }
            }

            .title {
                p {
                    padding: 5px 20px;

                    &.num {
                        font-size: 22px;
                        margin-bottom: 0;
                    }

                    &.detail {
                        opacity: 0.9;
                        font-size: 16px;
                    }
                }
            }
        }

        .body {
            padding: 5px 40px;

            .address_title {
                padding: 10px 10px 0;
                font-size: 22px;
                display: inline-block;
            }

            .address {
                .name {
                    font-size: 26px;
                    margin: 10px 0;
                }

                .info {
                    margin-top: 5px;

                    div {
                        margin-bottom: 5px;

                        p {
                            font-size: 18px;
                        }
                    }
                }
            }

            .table {
                margin-top: 20px;
                padding: 0;

                table {
                    tbody {
                        tr {
                            td {
                                font-size: 16px;

                                .button {
                                    display: none;
                                }
                            }
                        }
                    }

                    .total {
                        font-weight: bold;
                        text-align: center;
                    }

                    .primary {
                        color: #4952ff;
                        font-weight: bold;
                    }

                    .danger {
                        color: #ff7977;
                        font-weight: bold;
                    }
                }
            }
        }

        .footer {
            border-top: none;
            margin-top: 30px;
            padding-top: 30px;

            .pill {
                padding: 0 30px;

                div {
                    p {
                        font-size: 20px;
                        font-weight: 500;
                        color: #333;

                        // .currency {
                        //     left: ;
                        // }
                    }
                }
            }

            .amount {
                margin-top: 40px;

                .inv-num {
                    width: 60%;

                    .barcode {
                        width: 350px !important;
                        opacity: 0.4;
                    }

                    p {
                        font-size: 18px !important;
                    }
                }

                .inv-price {
                    width: 40%;

                    .inv-t {
                        font-size: 20px;
                    }

                    .inv-p {
                        font-weight: bold;
                        position: relative;

                        span {
                            &.n {
                                padding: 0 5px;
                                font-size: 28px;
                            }

                            &.c {
                                font-size: 10px;
                                position: initial;
                                width: 100px;
                            }
                        }
                    }

                    .button {
                        display: none;
                    }
                }
            }
        }
    }
}

.options {
    text-align: right;
    padding: 0 170px 0;

    .button {
        margin: 0 15px 40px;
        background: none;
        color: black;
        height: 30px;
        font-size: 14px;
        border-color: #777 !important;
    }
}
</style>
